import React from "react";
import LinkButton from "./link-button";
import ImageButton from "./image-button";
import {MediaOptions, RichTextTool} from "@common/components/forms/rich-text-form-field/tools/tools-types.enum";

interface MediaGroupProps {
    isLinkActive: boolean;
    currentLinkUrl: string | null;
    onInsertLink: (url: string) => void;
    onRemoveLink: () => void;
    onInsertImage: (file: File) => void;
    hiddenOptions?: RichTextTool[];
}

const MediaGroup: React.FC<MediaGroupProps> = (props) => {
    return (
        <>
            {!props.hiddenOptions?.includes(MediaOptions.LINK) && (
                <LinkButton
                    isActive={props.isLinkActive}
                    currentLinkUrl={props.currentLinkUrl}
                    onInsertLink={props.onInsertLink}
                    onRemoveLink={props.onRemoveLink}
                />
            )}
            {!props.hiddenOptions?.includes(MediaOptions.IMAGE) && (
                <ImageButton onInsertImage={props.onInsertImage}/>
            )}
        </>
    );
};

export default MediaGroup;
